import { Project } from '~/models/project'
import AdTemplate from '~/models/adTemplate'
import { Brand } from '~/models/brand'
import { Product } from '~/models/product'
import { TemplateCategory } from '~/models/templateCategory'
import { AdScript } from '~/models/adScript'

export default definePayloadPlugin(() => {
  definePayloadReducer('BrandModel', (data) => {
    if (data instanceof Brand)
      return data.toJSON()
  })

  definePayloadReviver('BrandModel', (data) => {
    return new Brand(data)
  })

  definePayloadReducer('ProjectModel', (data) => {
    if (data instanceof Project)
      return data.toJSON()
  })

  definePayloadReviver('ProjectModel', (data) => {
    return new Project(data)
  })

  definePayloadReducer('AdTemplateModel', (data) => {
    if (data instanceof AdTemplate)
      return data.toJSON()
  })

  definePayloadReviver('AdTemplateModel', (data) => {
    return new AdTemplate(data)
  })

  definePayloadReducer('ProductModel', (data) => {
    if (data instanceof Product)
      return data.toJSON()
  })

  definePayloadReviver('ProductModel', (data) => {
    return new Product(data)
  })

  definePayloadReducer('TemplateCategoryModel', (data) => {
    if (data instanceof TemplateCategory)
      return data.toJSON()
  })

  definePayloadReviver('TemplateCategoryModel', (data) => {
    return new TemplateCategory(data)
  })

  definePayloadReducer('AdScriptModel', (data) => {
    if (data instanceof AdScript)
      return data.toJSON()
  })

  definePayloadReviver('AdScriptModel', (data) => {
    return new AdScript(data)
  })

  definePayloadReducer('firebase-user', (data) => {
    if (data && typeof data === 'object' && 'email' in data && 'emailVerified' in data && typeof data.toJSON === 'function')
      return data.toJSON()
  })

  definePayloadReviver('firebase-user', (data) => {
    return data
  })
})
